import React from 'react'
import profile from '../Picture/image-avatar.png'
const Profile = () => {
  return (

           <div className="profile">
       <img src={profile} style={{width: '40%'}}
        alt="profile" />
       </div> 
    
  )
}

export default Profile